import Dexie, { Table } from 'dexie'
import {
    ItemEspañaENTITY,
    SomacylOrderENTITY,
    StockAlmacenENTITY,
    StockAlmacenEquiposENTITY,
    StockPersonalENTITY,
    StockPersonalEquiposENTITY
} from 'sigo-entities'

export interface BaseENTITY {
    pendingSync?: 0 | 1
    updatedAt?: number
    syncedAt?: number
}

export interface ItemEspañaOfflineENTITY extends ItemEspañaENTITY, BaseENTITY { }
export interface SomacylOrderOfflineENTITY extends SomacylOrderENTITY, BaseENTITY { }
export interface StockAlmacenOfflineENTITY extends StockAlmacenENTITY, BaseENTITY { }
export interface StockAlmacenEquiposOfflineENTITY extends StockAlmacenEquiposENTITY, BaseENTITY { }
export interface StockPersonalOfflineENTITY extends StockPersonalENTITY, BaseENTITY { }
export interface StockPersonalEquiposOfflineENTITY extends StockPersonalEquiposENTITY, BaseENTITY { }
export interface ImageOfflineENTITY extends BaseENTITY { id: string, file: File }

class AppDB extends Dexie {
    items_españa!: Table<ItemEspañaOfflineENTITY>
    somacyl_orders!: Table<SomacylOrderOfflineENTITY>
    stock_almacen!: Table<StockAlmacenOfflineENTITY>
    stock_almacen_equipos!: Table<StockAlmacenEquiposOfflineENTITY>
    stock_personal!: Table<StockPersonalOfflineENTITY>
    stock_personal_equipos!: Table<StockPersonalEquiposOfflineENTITY>
    images_somacyl_orders!: Table<ImageOfflineENTITY>

    constructor() {
        super('SIGO_OFFLINE_DB')

        this.version(1).stores({
            items_españa: '&Codigo,pendingSync,updatedAt',
            somacyl_orders: '&_id,estado_interno,pendingSync,updatedAt',
            stock_almacen_equipos: '&ID_StockAlmacenEquipos,ID_StockAlmacen,pendingSync,updatedAt',
            stock_almacen: '&ID_StockAlmacen,pendingSync,updatedAt',
            stock_personal_equipos: '&ID_StockPersonalEquipos,ID_StockPersonal,pendingSync,updatedAt',
            stock_personal: '&ID_StockPersonal,pendingSync,updatedAt',
            images_somacyl_orders: '&id,pendingSync,updatedAt'
        })
    }

    async clearAll() {
        await this.transaction(
            'rw',
            this.tables,
            async () => {
                await Promise.all(
                    this.tables.map((table) =>
                        table.clear()
                    )
                )
            }
        )
    }
}

export const indexedDB = new AppDB()
